import React from 'react';
import { useAuth } from '../../auth/useAuth';
import { Alert } from '../../services/Alert';
import { ToastContainer } from 'react-toastify';

import logo_xml from '../../assets/img/menu/invoice.svg';
import logo_price from '../../assets/img/menu/quotation.svg';
import { NavLink } from 'react-router-dom';

export const HomePage = () => {

  const user = useAuth();

  if(user.errmsg !== ''){
    Alert(user.errmsg,'error',{});
    user.errclear();
  }

  return (
    <div className="container mt-5 mb-5">
      <div className='row'>
        <h1 className='m8-h2 animated fadeIn'>Bienvenido { user.user.usuario }</h1>
      </div>
      <div className="row">
        <div className="col-12 col-sm-6 col-md-4 col-lg-3 p-3 animated fadeIn">
          <NavLink to="/upload" className="text-decoration-none">
            <div className="card">
              <div className='p-3'>
                <img src={ logo_xml } className="card-img-top p-6" alt="Subir facturas" />
              </div>
              <div className="card-body">
                <p className="card-title text-center m8-h3 fw-500">Subir facturas</p>
              </div>
            </div>
          </NavLink>
        </div>
        {
          user.user.tabla.toUpperCase()==='PROVEEDOR'?(
            <div className="col-12 col-sm-6 col-md-4 col-lg-3 p-3 animated fadeIn">
              <NavLink to="/price" className="text-decoration-none">
                <div className="card">
                  <div className='p-3'>
                    <img src={ logo_price } className="card-img-top" alt="Subir facturas" />
                  </div>
                  <div className="card-body">
                    <p className="card-title text-center m8-h3 fw-500">Cotizaciones</p>
                  </div>
                </div>
              </NavLink>
            </div>
          ):''
        }
      </div>
      <ToastContainer />
    </div>
  )
}